import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  softwarePackages: [],
  loadingSoftwarePackages: false,
};

const softwarePackageSlice = createSlice({
  name: "softwarePackage",
  initialState,
  reducers: {
    loadingSoftwarePackages(state) {
      state.loadingSoftwarePackages = true;
    },
    loadingSoftwarePackagesDone(state) {
      state.loadingSoftwarePackages = false;
    },
    setSoftwarePackages(state, action) {
      state.softwarePackages = action.payload;
    },
  },
});

export const {
  loadingSoftwarePackages,
  loadingSoftwarePackagesDone,
  setSoftwarePackages,
} = softwarePackageSlice.actions;

export default softwarePackageSlice.reducer;
